import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Appointments from "@/pages/Appointments";
import Treatments from "@/pages/Treatments";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Profile from "@/pages/Profile";
import AuditLog from "@/pages/AuditLog";
import PublicBooking from "@/pages/PublicBooking";
import ChatWidgetEmbed from "@/pages/ChatWidgetEmbed";
import Notifications from "@/pages/Notifications";
import UserGuide from "@/pages/UserGuide";
import Inventory from "@/pages/Inventory";
import Procedures from "@/pages/Procedures";
import Recalls from "@/pages/Recalls";
import DoctorSchedules from "@/pages/DoctorSchedules";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<PublicBooking />} />
            <Route path="/chat-widget" element={<ChatWidgetEmbed />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="pacientet" element={<Patients />} />
              <Route path="pacientet/:id" element={<PatientDetail />} />
              <Route path="takimet" element={<Appointments />} />
              <Route path="lajmerime" element={<Notifications />} />
              <Route path="udhezues" element={<UserGuide />} />
              <Route path="trajtimet" element={
                <ProtectedRoute roles={["admin","doctor","assistant"]}><Treatments /></ProtectedRoute>
              } />
              <Route path="faturimi" element={
                <ProtectedRoute roles={["admin","doctor","receptionist"]}><Billing /></ProtectedRoute>
              } />
              <Route path="raportet" element={
                <ProtectedRoute roles={["admin","doctor","receptionist"]}><Reports /></ProtectedRoute>
              } />
              <Route path="profili" element={<Profile />} />
              <Route path="inventari" element={
                <ProtectedRoute roles={["admin","doctor","receptionist","assistant"]}><Inventory /></ProtectedRoute>
              } />
              <Route path="procedurat" element={
                <ProtectedRoute roles={["admin","doctor","receptionist","assistant"]}><Procedures /></ProtectedRoute>
              } />
              <Route path="kujtuesit" element={
                <ProtectedRoute roles={["admin","doctor","receptionist"]}><Recalls /></ProtectedRoute>
              } />
              <Route path="audit" element={
                <ProtectedRoute roles={["admin"]}><AuditLog /></ProtectedRoute>
              } />
              <Route path="cilesimet" element={
                <ProtectedRoute roles={["admin"]}><Settings /></ProtectedRoute>
              } />
              <Route path="orari-doktoreve" element={
                <ProtectedRoute roles={["admin"]}><DoctorSchedules /></ProtectedRoute>
              } />
            </Route>
          </Routes>
          </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
